import { COUNTRY_CODE } from "../../constants/app-constants";
import priceFormatter from "./price-formatter";

const makeOdometerLabel = (price, country = COUNTRY_CODE.IN) => `${priceFormatter(price, true, country)} km`;

export const makeOdometerLabelAE = (price) => {
    return makeOdometerLabel(Math.round(price), COUNTRY_CODE.AE);
};

export const makeOdometerLabelAU = (price) => {
    return makeOdometerLabel(Math.round(price), COUNTRY_CODE.AU);
};

const makeOdometerLabelShort = (price, country = COUNTRY_CODE.IN) => `${priceFormatter(price, true, country)}k km`;

export const makeOdometerLabelAUShort = (price) => {
    return price ? makeOdometerLabelShort(Math.round(price), COUNTRY_CODE.AU) : `${0} km`;
};

export default makeOdometerLabel;
